import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/facebook.png'
import _imports_1 from '@/assets/images/instagram.png'
import _imports_2 from '@/assets/images/linkedin.png'
import _imports_3 from '@/assets/images/wa.png'
import _imports_4 from '@/assets/images/mail.png'
import _imports_5 from '@/assets/images/logo.png'
import _imports_6 from '@/assets/images/search.png'
import _imports_7 from '@/assets/images/icons/cart.png'


const _withScopeId = n => (_pushScopeId("data-v-1412829d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navigation" }
const _hoisted_2 = { class: "nav-btn" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "row m-0 justify-content-between" }
const _hoisted_6 = { class: "col-sm-3 d-flex justify-content-center justify-content-sm-start mb-2 mb-sm-0" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"col-sm-9 d-flex justify-content-center justify-content-sm-end part2\" data-v-1412829d><div class=\"topLinks mr-4\" data-v-1412829d><img src=\"" + _imports_3 + "\" alt=\"\" data-v-1412829d><a href=\"https://api.whatsapp.com/send/?phone=0633456787\" data-v-1412829d>Whatsapp: 0633456787</a></div><div class=\"topLinks\" data-v-1412829d><img src=\"" + _imports_4 + "\" alt=\"\" data-v-1412829d><a href=\"mailto:info@dutchflowers.com\" data-v-1412829d>info@dutchflowers.com</a></div></div>", 1)
const _hoisted_11 = {
  key: 0,
  class: "blocked-dates"
}
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "content" }
const _hoisted_14 = { class: "navbar navbar-expand-lg" }
const _hoisted_15 = { class: "container d-flex align-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "nav-logo",
  src: _imports_5,
  alt: "",
  width: "100px"
}, null, -1))
const _hoisted_17 = { class: "d-none d-lg-block" }
const _hoisted_18 = { class: "headerIcons d-lg-none" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "search-icon nav-link",
  role: "search"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "cart-count"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fa fa-bars" }, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "navbar-nav ms-auto mb-2 mb-lg-0" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Shop")
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Blog")
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Contact")
const _hoisted_33 = { class: "d-lg-none" }
const _hoisted_34 = { class: "text-center mb-2" }
const _hoisted_35 = { class: "headerAction d-flex align-items-center" }
const _hoisted_36 = { class: "headerIcons d-none d-lg-block" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "search-icon nav-link",
  role: "search"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    alt: ""
  })
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  alt: ""
}, null, -1))
const _hoisted_39 = {
  key: 0,
  class: "cart-count"
}
const _hoisted_40 = {
  key: 0,
  class: "headerButtons ml-md-2"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  type: "submit"
}, "Registration", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-outline",
  type: "submit"
}, "Sign In", -1))
const _hoisted_43 = {
  key: 1,
  class: "headerButtons ml-md-2"
}
const _hoisted_44 = { class: "dropdownWrapper" }
const _hoisted_45 = { class: "inner" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Profile")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Orders")
const _hoisted_48 = { class: "item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LangSwitch = _resolveComponent("LangSwitch")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, { to: "" }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _hoisted_10
          ])
        ])
      ])
    ]),
    (_ctx.blockedDates.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("unavailableToOrder")), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, {
          class: "navbar-brand",
          to: "/"
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_LangSwitch)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_router_link, {
            to: "/cart",
            class: "nav-link cart-icon"
          }, {
            default: _withCtx(() => [
              _hoisted_20,
              (_ctx.cart && _ctx.cart.rows && _ctx.cart.rows.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.cart.rows.length), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            class: "navbar-toggler",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args)))
          }, _hoisted_23)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["collapse navbar-collapse", { show: _ctx.showMenu }])
        }, [
          _createElementVNode("ul", _hoisted_24, [
            _createElementVNode("li", _hoisted_25, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/"
              }, {
                default: _withCtx(() => [
                  _hoisted_26
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_27, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/shopping"
              }, {
                default: _withCtx(() => [
                  _hoisted_28
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_29, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/blog"
              }, {
                default: _withCtx(() => [
                  _hoisted_30
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", _hoisted_31, [
              _createVNode(_component_router_link, {
                class: "nav-link",
                to: "/contact"
              }, {
                default: _withCtx(() => [
                  _hoisted_32
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_LangSwitch)
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createVNode(_component_router_link, {
                to: "/cart",
                class: "nav-link cart-icon"
              }, {
                default: _withCtx(() => [
                  _hoisted_38,
                  (_ctx.cart && _ctx.cart.items_qty && _ctx.cart.items_qty > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.cart.items_qty), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            (!_ctx.token)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createVNode(_component_router_link, {
                    class: "navbar-brand",
                    to: "/registration"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_41
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_router_link, {
                    class: "navbar-brand",
                    to: "/sign-in"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_42
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", {
                      class: "main",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showMan && _ctx.showMan(...args)))
                    }, [
                      _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.userFirstName.charAt(0)), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["drop", { active: _ctx.showPs }])
                    }, [
                      _createElementVNode("div", {
                        class: "item",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showMan && _ctx.showMan(...args)))
                      }, [
                        _createElementVNode("span", null, [
                          _createVNode(_component_router_link, { to: "/profile" }, {
                            default: _withCtx(() => [
                              _hoisted_46
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "item",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showMan && _ctx.showMan(...args)))
                      }, [
                        _createElementVNode("span", null, [
                          _createVNode(_component_router_link, { to: "/orders" }, {
                            default: _withCtx(() => [
                              _hoisted_47
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("span", {
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                        }, "Logout")
                      ])
                    ], 2)
                  ])
                ]))
          ])
        ], 2)
      ])
    ])
  ]))
}